import React from "react";
import "./ScorecardSummaryRowHoleScoreCell.css"; // Import the CSS file
import getThrowIndicator from "./getThrowIndicator";

function ScorecardSummaryRowHoleScoreCell({
  score,
  index,
  throwScoringModeId,
  small,
}) {
  //check hole.throw_scores array for a row with throw_number === 1
  const throwOneScore = score.throw_scores?.find(
    (throw_score) => throw_score.throw_number === 1
  )?.throw_score;

  // Get the result value for throw_number === 2
  const throwTwoScore = score.throw_scores?.find(
    (throw_score) => throw_score.throw_number === 2
  )?.throw_score;

  const isScoreNull = score.score === null;

  return (
    <td key={index} className="scorecard-summary-cell-outer-td">
      {/* if small=true, apply class .scorecard-summary-total-score-cell-small to table */}
      <table className="scorecard-summary-cell-table">
        <tbody>
          <tr>
            <td className="scorecard-summary-empty-cell"></td>
            <td className="scorecard-summary-empty-cell"></td>
            <td className="scorecard-summary-empty-cell"></td>
            <td className="scorecard-summary-top-right-score-cell">
              {throwScoringModeId > 1 && isScoreNull ? "" : score.score}
            </td>
          </tr>
          <tr>
            <td
              colSpan={4}
              className={
                small
                  ? "scorecard-summary-hole-score-cell-small"
                  : "scorecard-summary-middle-score-cell"
              }
            >
              {throwScoringModeId > 1 && !isScoreNull
                ? score.hole_score_adv
                : isScoreNull
                ? "-"
                : score.score}
            </td>
          </tr>
          <tr
            className={`scorecard-summary-throw-score-cell${
              small ? "-small" : ""
            }`}
          >
            <td colSpan={2}>{getThrowIndicator(throwOneScore)}</td>
            <td colSpan={2}>{getThrowIndicator(throwTwoScore)}</td>
          </tr>
        </tbody>
      </table>
    </td>
  );
}

export default ScorecardSummaryRowHoleScoreCell;
